import { render, staticRenderFns } from "./BsGridFooterCell.vue?vue&type=template&id=fef57836&scoped=true&"
import script from "./BsGridFooterCell.vue?vue&type=script&lang=js&"
export * from "./BsGridFooterCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fef57836",
  null
  
)

export default component.exports